import { forwardRef, type Ref, type SVGProps } from "react";
const IconCalculatorFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M26 2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M11 26H9a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2m0-4H9a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2m0-4H9a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2m6 8h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2m0-4h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2m0-4h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2m6 8h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2m0-4h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2m0-4h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2m1-5.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCalculatorFilledSVG);
ForwardRef.displayName = "IconCalculatorFilled";
export { ForwardRef as IconCalculatorFilled };
